import { SharedKPIWidget } from '../shared/kpi/SharedKPIWidget';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';
import { useAdminTotalLeadsAdapter } from './adapters/adminKpiAdapters';

export const adminTotalLeadsConfig: WidgetConfig = {
  id: 'admin-total-leads',
  title: 'Total Leads',
  icon: 'database',
  category: 'statistics',
  description: 'Total number of leads in the system',
  refreshStrategy: 'interval',
  defaultSize: { w: 2, h: 1 },
  priority: 1,
  supportedRoles: ['admin', 'superadmin'],
};

export function AdminTotalLeadsWidget() {
  const dataQuery = useAdminTotalLeadsAdapter();

  return (
    <SharedKPIWidget
      config={adminTotalLeadsConfig}
      dataQuery={dataQuery}
      color="primary"
    />
  );
}
